import { Configuration, LogLevel } from "@azure/msal-browser";
import { config } from "../Utility/Constants";

const azureActiveDirectoryAppClientId: any = config.aadClientID;
const tenantId: any = config.tenantID;
// const redirectUri: any = config.redirectUri;

export const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: azureActiveDirectoryAppClientId,
    authority: `https://login.microsoftonline.com/${tenantId}`, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    // redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            return;
          case LogLevel.Warning:
            //console.warn(message);
            return;
        }
      },
    },
  },
};
